module.exports = __webpack_public_path__ + "static/media/halloween-box.787e2cc5.png";